import { Box, Paper } from "@mui/material";
import { SawShiftProduction } from "../models/types";
import {
	CardBodySx,
	CardPaperSx,
	CardTitle,
	InfoGrid,
	InfoGridItem,
	SawChip,
} from "./primitives";

type Props = {
	title: string;
	subtitle?: string; // "Shift B · Crew 2" — rides as the title chip
	accent: string;
	accentDark: string;
	metrics?: SawShiftProduction | null;
	includeRun?: boolean; // "Per Product Run" — current shift only
};

// One shift's output as a quiet InfoGrid card, same shape as the product
// cards above it; the shift's accent only tints the chip.
export const ShiftCard = ({
	title,
	subtitle,
	accent,
	accentDark,
	metrics = null,
	includeRun = false,
}: Props) => {
	const items: InfoGridItem[] = [
		{
			label: "Finished Bundles / Shift",
			value: metrics?.finishBundlesCutPerShift ?? null,
		},
		{
			label: "Finished Bundles / Hour",
			value: metrics?.finishedBundlesPerHr ?? null,
		},
	];
	if (includeRun) {
		items.push({
			label: "Per Product Run",
			value: metrics?.finishBundlesCutPerProductRun ?? null,
		});
	}

	return (
		<Paper elevation={1} sx={CardPaperSx}>
			<CardTitle
				title={title}
				action={
					subtitle ? (
						<SawChip label={subtitle} accent={accent} accentDark={accentDark} />
					) : undefined
				}
			/>
			<Box sx={CardBodySx}>
				<InfoGrid columns={1} items={items} />
			</Box>
		</Paper>
	);
};
